import {
  openDB,
  type DBSchema,
  type IDBPDatabase,
} from 'idb'

export const NOME_BANCO_CATALOGOS = 'pontotel-catalogos'
export const VERSAO_BANCO_CATALOGOS = 2
export const IDENTIFICADOR_CHAVE_CATALOGOS = 'catalogos-aes-gcm-v1'

export type RegistroCatalogoPersistido = Readonly<{
  chave: string
  catalogo: string
  contextoHash: string
  versaoProjecao: number
  sincronizadoEm: number
  ultimoAcessoEm: number
  invalidadoEm?: number
  algoritmo: 'AES-GCM'
  iv: Uint8Array<ArrayBuffer>
  conteudoCifrado: ArrayBuffer
}>

export type ContextoCatalogoPersistido = Readonly<{
  contextoHash: string
  ultimoAcessoEm: number
}>

export type ChaveCatalogosPersistida = Readonly<{
  id: string
  chave: CryptoKey
}>

export interface BancoCatalogosSchema extends DBSchema {
  catalogos: {
    key: string
    value: RegistroCatalogoPersistido
    indexes: { 'por-contexto': string }
  }
  contextos: {
    key: string
    value: ContextoCatalogoPersistido
    indexes: { 'por-ultimo-acesso': number }
  }
  chaves: {
    key: string
    value: ChaveCatalogosPersistida
  }
}

export type BancoCatalogos = IDBPDatabase<BancoCatalogosSchema>

export const abrirBancoCatalogos = (
  nomeBanco = NOME_BANCO_CATALOGOS,
): Promise<BancoCatalogos> => openDB<BancoCatalogosSchema>(
  nomeBanco,
  VERSAO_BANCO_CATALOGOS,
  {
    upgrade (banco, versaoAnterior, _novaVersao, transacao) {
      if (versaoAnterior < 1) {
        const catalogos = banco.createObjectStore('catalogos', {
          keyPath: 'chave',
        })
        catalogos.createIndex('por-contexto', 'contextoHash')

        const contextos = banco.createObjectStore('contextos', {
          keyPath: 'contextoHash',
        })
        contextos.createIndex('por-ultimo-acesso', 'ultimoAcessoEm')
      }

      if (versaoAnterior < 2) {
        void transacao.objectStore('catalogos').clear()
        void transacao.objectStore('contextos').clear()
        banco.createObjectStore('chaves', { keyPath: 'id' })
      }
    },
    blocking (_versaoAtual, _novaVersao, evento) {
      const banco = evento.target as IDBDatabase | null
      banco?.close()
    },
  },
)
